export function addVariant({
  variantId: id, qty: quantity, properties = null, callback,
}) {
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ id, quantity, properties }),
  })
    .then((response) => response.json())
    .then((item) => {
      if (item.status) {
        // eslint-disable-next-line no-alert
        alert(item.description);
        if (callback) {
          callback(quantity);
        }
      } else if (callback) {
        callback(quantity);
      }
    });
}

export function addMultipleVariants(itemsArray, callback) {
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ items: itemsArray }),
  })
    .then((response) => response.json())
    .then((item) => {
      if (item.status) {
        // eslint-disable-next-line no-alert
        alert(item.description);
        if (callback) {
          callback();
        }
      } else if (callback) {
        callback();
      }
    });
}
